<template>
  <div>
    <top></top>
    <el-carousel style="width: 100%;height: 320px;" indicator-position="none">
      <el-carousel-item style="width: 100%;height: 320px;">
        <img class="swiper-img" src="../../../static/images/swiper4.jpg"/>
      </el-carousel-item>
    </el-carousel>
    <menutree :menuchild="menuchild" checkMenu="3" :rightBars="rightBars"></menutree>
    <div class="aboutus_content_box">
      <div class="aboutus_content">
        <div class="search_box">
          <div>
            项目名称
          </div>
          <div class="input_box">
            <input v-model="title" placeholder="请输入项目名称"/>
          </div>
          <div class="search_bt pointer" @click="getData()">
            搜索
          </div>
        </div>
        <div class="table_box">
          <div class="table_title_box">
            <div class="title_left">
              项目名称
            </div>
            <div class="title_right">
              报告提交时间
            </div>
          </div>
          <div class="table_content pointer" v-for="(item,index) in dataList" :key="index" @click="goReportInfo(item)">
            <div class="content_left">
              {{item.title}}
            </div>
           <div class="content_right">
              {{item.publishTime}}
            </div>
          </div>
          <div class="no_data" v-if="dataList.length < 1">
            暂无数据
          </div>
        </div>
        <div class="pagination_box" v-if="dataList.length > 0">
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="currentChange"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import top from '@/components/top.vue';
import menutree from '@/components/menutree.vue';
import bottom from '@/components/bottom.vue';
export default {
  components:{top,menutree,bottom},
  data () {
    return {
      dataList:[],
      total:1,
      page:1,
      title:'',
      menuchild:[{
        lable:'职业卫生报告',
        value:'1',
        path:'/reports'
      },{
        lable:'信息公示',
        value:'3',
        path:'/publicNotice'
      },{
        lable:'新闻资讯',
        value:'2',
        path:'/newsList'
      }],
      rightBars:[{
        lable:'首页',
        path:'/',
      },{
        lable:'信息公开',
        path:'',
      },{
        lable:'信息公示',
        path:'',
      }]
    }
  },
  mounted() {
    this.getData()
  },
  methods:{
    goReportInfo(item){
      const{ href } = this.$router.resolve({name:'reportInfo',query:{id:item.id,menu:3}})
      // console.log(newPage)
      window.open(href,'_blank')
    },
    currentChange(e){
      this.page = e;
      this.getData()
    },
    getData(){
      const url='https://api.hzshjc.com/index/caseList';
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background:'rgba(0, 0, 0, 0)'
      });
      let data = {
        pageSize:10,
        pageNum:this.page,
        title:this.title,
        type:'info'
      }
      this.$axios({
        method:'get',
        url:url,
        params:data
      }).then(res=>{
        if(res.data.code=='200'){
          this.dataList = res.data.rows;
          this.total = res.data.total;
        }
        loading.close()
      })
    }
  }
}
</script>

<style scope lang="less">
  .swiper-img{
    width: 100%;
    height: 320px;
  }
  .aboutus_content_box{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: calc(50vh);
    .aboutus_content{
      width: 1200px;
      padding:40px 0;
      font-size: 14px;
      color: #666;
      line-height: 30px;
    }
  }
  .search_box{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 10px 0 40px;
    line-height: 44px;
    color: #333;
    font-size: 16px;
    .input_box{
      input{
        height: 50px;
        width: 438px;
        border: none;
        margin: 0 20px;
        padding:0 20px;
        border: 1px #e6e6e6 solid;
        font-size: 16px;
        border-radius: 3px;
        -moz-border-radius: 3px;
        -webkit-border-radius: 3px;
      }
    }
    .search_bt{
      width: 120px;
      display: block;
      line-height: 44px;
      color: #fff;
      font-size: 16px;
      float: left;
      text-align: center;
      margin-left: 20px;
      border: 0px;
      background-color: #00a73c;
      border-radius: 3px;
      -moz-border-radius: 3px;
      -webkit-border-radius: 3px;
    }
  }
  .table_box{
    min-height: 600px;
    .table_title_box{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      line-height: 50px;
      text-align: center;
      background-color: #e6e6e6;
      font-size: 16px;
      color: #333;
      .title_left{
        width: 908px;
        border-right: 1px #fff solid;
      }
      .title_right{
        width: 290px;
      }
    }
    .table_content{
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: calc(1200px - 60px);
      line-height: 49px;
      text-align: left;
      font-size: 16px;
      color: #00a73c;
      padding:0 30px;
      border-bottom: 1px #e6e6e6 solid;
      .content_left{
        width: 848px;
        // border-right: 1px #e6e6e6 solid;
        float: left;
        font-size: 14px;
        padding: 0 30px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        // border-left: 1px #e6e6e6 solid;
        // border-right: 1px #e6e6e6 solid;
        // border-bottom: 1px #e6e6e6 solid;
        line-height: 50px;
      }
      .content_right{
        width: 289px;
        float: left;
        font-size: 14px;
        text-align: center;
        // border-right: 1px #e6e6e6 solid;
        // border-bottom: 1px #e6e6e6 solid;
      }
    }
    .table_content:hover{
      background: #00a73c;
      color: #FFF;
    }
    .no_data{
      height: 300rpx;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 50px;
    }
  }
  .pagination_box{
    width: 100%;
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active{
    background-color: #00a73c !important;
    color: #FFF;
  }
  .el-pager li:hover {
    color: #00a73c !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/reports/publicNotice.vue